module.exports = __webpack_public_path__ + "img/image_106.16b57f71.png";